<div class="modal-header">
  <h4 class="modal-title poppins" id="modal-basic-title">Filter pairs</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.close('Cross click')">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" class="d-flex flex-column filter-form">
    <div class="d-flex justify-content-between" *ngIf="filterCategory === FilterCategory.DAY_OF_OPERATION">
      <label for="timespan">Time Span:</label>
      <div class="input-group">
        <select class="form-select roboto-font" id="timespan" formControlName="timespan" [ngClass]="{ 'blue-option': form.value.timespan !== 'null' && form.value.timespan !== null }">
          <option [ngValue]="null">Time Span</option>
          <option value="8Hours">next 8 hours</option>
          <option value="12Hours">next 12 hours</option>
          <option value="24Hours">next 24 hours</option>
        </select>
      </div>
    </div>
<!--    <div class="d-flex justify-content-between">-->
<!--      <label for="acType" class="align-self-center">AC Type:</label>-->
<!--      <div class="input-group">-->
<!--        <select id="acType" class="form-select roboto-font" formControlName="acType" [ngClass]="{ 'blue-option': form.value.timespan !== 'null' && form.value.timespan !== null }">-->
<!--          <option value="null" selected>No filter</option>-->
<!--          <option *ngFor="let acType of getAvailableAcTypes" [ngValue]="acType">{{acType?.iata}}</option>-->
<!--        </select>-->
<!--      </div>-->
<!--    </div>-->
    <div class="d-flex justify-content-between">
      <label for="acRegistration" class="align-self-center">AC Registration:</label>
      <div class="input-group">
        <select id="acRegistration" class="form-select roboto-font" formControlName="acRegistration" [ngClass]="{ 'blue-option': form.value.timespan !== 'null' && form.value.timespan !== null }">
          <option value="null" selected>No filter</option>
          <option *ngFor="let acRegistration of getAvailableAcRegistrations" [ngValue]="acRegistration">{{acRegistration?.registration}}</option>
        </select>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <label for="flightNumber" class="align-self-center">Flight Number:</label>
      <div class="input-group">
        <input formControlName="flightNumber" id="flightNumber" class="form-control">
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <label for="passengerGate" class="align-self-center">Passenger Gate:</label>
      <div class="input-group">
        <input formControlName="passengerGate" id="passengerGate" class="form-control">
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <label for="aircraftStand" class="align-self-center">Aircraft Stand:</label>
      <div class="input-group">
        <input formControlName="aircraftStand" id="aircraftStand" class="form-control">
      </div>
    </div>
    <ng-container *ngIf="filterCategory !== FilterCategory.DAY_OF_OPERATION">
      <div class="d-flex justify-content-between">
        <label for="dateFrom" class="align-self-center">Date from:</label>
        <div class="input-group">
          <input type="text" class="form-control" formControlName="dateFrom" id="dateFrom" ngbDatepicker #to="ngbDatepicker" (focusin)="to.open()" (click)="to.open()" [autoClose]="true" (dateSelect)="to.close()" />
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <label for="dateTo" class="align-self-center">Date to:</label>
        <div class="input-group">
          <input type="text" class="form-control" formControlName="dateTo" id="dateTo" ngbDatepicker #from="ngbDatepicker" (focusin)="from.open()" (click)="from.open()" [autoClose]="true" (dateSelect)="from.close()" />
        </div>
      </div>
    </ng-container>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn custom-button-1" [disabled]="form?.invalid" (click)="okClicked()">
    <span>OK</span></button>
</div>
